export default "__VITE_ASSET__CzGX7eb1__"